import {useQuery} from 'react-query'
import {HawalaBranchEditModalForm} from './HawalaBranchEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getHawalaBranchById} from '../core/_requests'

const HawalaBranchEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: hawala_branch,
    error,
  } = useQuery(
    `${QUERIES.USERS_LIST}-hawala_branch-${itemIdForUpdate}`,
    () => {
      return getHawalaBranchById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )
  if (!itemIdForUpdate) {
    return <HawalaBranchEditModalForm isHawalaBranchLoading={isLoading} hawala_branch={{id: undefined}} />
  }

  if (!isLoading && !error && hawala_branch) {
    return <HawalaBranchEditModalForm isHawalaBranchLoading={isLoading} hawala_branch={hawala_branch} />
  }

  return null
}

export {HawalaBranchEditModalFormWrapper}
